<template>
  <div class="app-container">
    <el-form :inline="false" label-position="top" size="small">
      <el-row :gutter="20">
        <el-col :span="5">
          <!--  运单号   -->
          <el-form-item>
            <template slot="label">
              <div class="selectLabel">
                <el-select v-model="queryForm.params.selectType">
                  <el-option key="1" :label="$t('GlobalSetObj.waybillNumber')" :value="1" />
                  <el-option key="2" :label="$t('GlobalSetObj.ScanNumber')" :value="2" />
                </el-select>
              </div>
            </template>
            <el-input
              v-model="queryForm.params.inputValue"
              :placeholder="$t('newOrder.PreciseSearch1')"
              :rows="1"
              style="width: 100%"
              type="textarea"
            />
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <!-- 运单状态  -->
          <el-form-item :label="$t('collectionCenter.shipmentStatus')">
            <el-select
              v-model="queryForm.params.waybillStatusList"
              :placeholder="$t('GlobalSetObj.pleaseChoose')"
              clearable
              multiple
              style="width: 100%"
            >
              <el-option
                v-for="(item, ind) in selectStatusList"
                :key="ind"
                :label="item.label"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <!-- 客户名称  -->
          <el-form-item :label="$t('collectionCenter.CustomerName')">
            <el-select
              v-model="queryForm.params.customerIdList"
              :placeholder="$t('collectionCenter.pleaseChoose')"
              clearable
              filterable
              multiple
              style="width: 100%"
            >
              <el-option
                v-for="item in customerNameList"
                :key="item.id"
                :label="item.username"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <!--  停更时长 -->
          <el-form-item :label="$t('trajectory.updateDuration')">
            <el-select
              v-model="queryForm.params.trackStopAlertDays"
              :placeholder="$t('GlobalSetObj.pleaseChoose')"
              clearable
              filterable
              style="width: 100%"
            >
              <el-option
                v-for="item in 19"
                :key="item"
                :label="item + 1 + $t('WorkCentreTable.Day')"
                :value="item + 1"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <div style="margin-bottom: 15px">
            <!--搜索-->
            <el-button
              icon="el-icon-search" size="small" type="primary"
              @click="enterSearch"
            >{{ $t('newOrder.search') }}
            </el-button>
            <!--重置-->
            <el-button
              icon="el-icon-refresh-left" size="small" type="info"
              @click="resetForm()"
            >{{ $t('newOrder.reset') }}
            </el-button>
            <el-button
              size="small" type="primary" @click="manualTrackingAddition"
            >{{ $t('trajectory.supplementRecords') }}
            </el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <!--  表格数据  -->
    <el-table
      ref="tableRef"
      :data="tableData"
      :header-cell-style="{ background: '#f2f2f2', color: 'black' }"
      border
      row-key="waybillNumber"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        :reserve-selection="true"
        align="center"
        fixed="left"
        type="selection"
        width="50"
      />
      <el-table-column
        :label="$t('GlobalSetObj.serial')" align="center" type="index"
        width="80"
      />
      <el-table-column
        v-for="item in tableHeaderList"
        :key="item.id"
        :align="item.center"
        :label="item.label"
        :min-width="item.cloWidth"
        :prop="item.prop"
        :show-overflow-tooltip="false"
      >
        <template slot-scope="scope">
          <div>{{ scope.row[item.prop] ? `${scope.row[item.prop]}` : '--' }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="stationaryDays" sortable width="180">
        <template slot="header">
          <span>
            <span style="margin-right: 2px">{{ $t('trajectory.updateDuration') }}</span>
            <el-tooltip placement="top">
              <div slot="content">{{ $t('trajectory.redAlertThreshold') }}</div>
              <svg-icon icon-class="QuestionMark" />
            </el-tooltip>
          </span>
        </template>
        <template slot-scope="scope">
          <div :style="{ color: scope.row.isAlert === 1 ? 'red' : '' }">
            {{ scope.row.stationaryDays }}
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!--  分页  -->
    <el-pagination
      :current-page="queryForm.pageNumber"
      :page-size="queryForm.pageSize"
      :page-sizes="[10, 20, 50, 100]"
      :total="queryForm.total"
      background
      layout="total, sizes, prev, pager, next, jumper"
      style="margin: 10px 0; float: right"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { queryAllCustomer } from '@/api/lanshou';
import { stationaryAlertPage, stationaryAlertPushTrack } from '@/api/newExpressAPI';
import { waybillStatusList } from '@/utils/enumData';

export default {
  name: 'TrajectoryUpdateManagement',
  data() {
    return {
      // 是否格式化成巴西时间
      isTormat: false,
      zhDate: 'yyyy-MM-dd HH:mm:ss',
      ptDate: 'dd-MM-yyyy HH:mm:ss',
      timeValue: [],
      selectList: [],
      customerNameList: [],
      selectStatusList: waybillStatusList,
      queryForm: {
        pageSize: 10,
        pageNumber: 1,
        total: 0,
        params: {
          timeType: 1,
          selectType: 1,
          businessType: '',
          operationSiteId: '',
          inputValue: '',
          trackStopAlertDays: '',
          customerIdList: [],
          waybillStatusList: []
        }
      },
      tableData: [],
      tableHeaderList: [
        // 客户
        {
          id: 1,
          label: this.$t('collectionCenter.client'),
          prop: 'customerName',
          cloWidth: '150',
          center: 'center'
        },
        // 运单号
        {
          id: 2,
          label: this.$t('GlobalSetObj.waybillNumber'),
          prop: 'waybillNumber',
          cloWidth: '140',
          center: 'center'
        },
        // 扫描单号
        {
          id: 3,
          label: this.$t('GlobalSetObj.ScanNumber'),
          prop: 'scanNumber',
          cloWidth: '140',
          center: 'center'
        },
        // 运单状态
        {
          id: 4,
          label: this.$t('collectionCenter.shipmentStatus'),
          prop: 'waybillStatusName',
          cloWidth: '160',
          center: 'center'
        },
        // 最新轨迹内容
        {
          id: 5,
          label: this.$t('orderCenterCont.zuixinguijineir'),
          prop: 'latestTraceContent',
          cloWidth: '160',
          center: 'center'
        },
        // 最新轨迹时间
        {
          id: 6,
          label: this.$t('orderCenterCont.TheLatestTraceTime'),
          prop: 'latestTraceTime',
          cloWidth: '160',
          center: 'center'
        },
        // 轨迹节点
        {
          id: 7,
          label: this.$t('home.trackingNode'),
          prop: 'trackStatusName',
          cloWidth: '160',
          center: 'center'
        },
        // 预警阈值
        {
          id: 8,
          label: this.$t('trajectory.warningThreshold'),
          prop: 'trackStopAlertDays',
          cloWidth: '160',
          center: 'center'
        }
      ],
      customerList: [], // 用户列表
      timeLable: [
        { id: 1, label: this.$t('routes.CollectionTime') },
        { id: 2, label: this.$t('routes.loadingCompletionTime') },
        { id: 3, label: this.$t('GlobalSetObj.unCarTime') }
      ]
    };
  },
  computed: {
    IsWidth() {
      return {
        width: this.isTormat ? '250px' : '160px'
      };
    }
  },
  created() {
    if (this.$i18n.locale !== 'zh') {
      this.isTormat = true;
    }
    this.getTimer();
    this.getSearch(1);
    this.getAllCustomer();
  },
  methods: {
    // 查询
    getSearch(val) {
      let inputValList = [];
      if (this.queryForm.params.inputValue) {
        // 单号格式化，去除空格
        const orderNumber = this.queryForm.params.inputValue.split(/[(\r\n)\r\n]+/);
        orderNumber.map((item) => {
          if (item) {
            inputValList.push(item.trim());
          }
        });
      }
      if (inputValList.length > 2000) {
        this.$message.warning(this.$t('newOrder.searchMax1000'));
        inputValList = inputValList.slice(0, 2000); // 截取前2000个单号
      }
      const data = {
        params: {
          customerIdList: this.queryForm.params.customerIdList,
          waybillStatusList: this.queryForm.params.waybillStatusList,
          trackStopAlertDays: this.queryForm.params.trackStopAlertDays,
          waybillNumberList: [],
          scanNumberList: []
        }
      };
      data.pageSize = this.queryForm.pageSize;
      data.pageNumber = this.queryForm.pageNumber;
      if (this.queryForm.params.selectType === 1) {
        data.params.waybillNumberList = inputValList;
      } else {
        data.params.scanNumberList = inputValList;
      }
      let loading = null;
      if (val === 1) {
        loading = this.$loading({
          fullscreen: true,
          lock: true,
          spinner: 'el-icon-loading',
          text: 'loading...',
          background: 'rgba(250, 250, 250, 0.6)'
        });
      }
      stationaryAlertPage(data).then((res) => {
        if (res.code === 200) {
          if (val === 1) {
            loading.close();
          }
          this.queryForm.total = res.data.total;
          this.tableData = res.data.records;
          console.log(this.tableData, ' this.tableData');
        }
      });
    },
    manualTrackingAddition() {
      const data = {
        waybillNumberList: []
      };
      data.waybillNumberList = this.selectList.map((item) => item.waybillNumber);
      const h = this.$createElement;
      this.$msgbox({
        title: this.$t('trajectory.manualTrackingAddition'),
        message: h('p', null, [
          // 第一个div添加 font-weight: bold 实现加粗
          h('div', { style: 'font-weight: bold;' }, this.$t('trajectory.confirmTrackingAddition')),
          h('div', { style: '' }, this.$t('trajectory.systemAutoAddition'))
        ]),
        showCancelButton: true,
        confirmButtonText: this.$t('GlobalSetObj.Confirm'),
        cancelButtonText: this.$t('GlobalSetObj.cancel'),
        type: 'warning'
      }).then(() => {
        stationaryAlertPushTrack(data).then((res) => {
          if (res.code === 200) {
            this.$refs.tableRef.clearSelection();
            this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
            this.getSearch(1);
          }
        });
      });
    },
    // 获取最近一周时间
    getTimer() {
      // 获取当前时间
      const today = dayjs().format('YYYY-MM-DD');
      const oneWeekAgo = dayjs().subtract(1, 'months').format('YYYY-MM-DD');
      this.timeValue = [oneWeekAgo + ' 00:00:00', today + ' 23:59:59'];
    },
    enterSearch() {
      this.queryForm.pageNumber = 1;
      this.getSearch();
    },
    // 重置
    resetForm() {
      this.queryForm.pageNumber = 1;
      this.getTimer();
      this.queryForm.params = {
        timeType: 1,
        selectType: 1,
        businessType: '',
        operationSiteId: '',
        inputValue: ''
      };
      this.getSearch();
      this.$refs.tableRef.clearSelection();
    },
    // 点击分页
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.queryForm.pageNumber = 1;
      this.getSearch();
    },
    handleCurrentChange(val) {
      this.queryForm.pageNumber = val;
      this.getSearch();
    },
    handleSelectionChange(val) {
      this.selectList = val;
    },
    getAllCustomer() {
      // 查询所有客户信息
      queryAllCustomer().then((res) => {
        if (res.code === 200) {
          this.customerNameList = [];
          res.data.forEach((list) => {
            this.customerNameList.push({
              id: list.id,
              username: list.username
            });
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep {
  .drawerClass header {
    border-bottom: 1px solid #aaa !important;
    margin-bottom: 0 !important;
    padding: 20px 20px 20px !important;
  }
}

.selectLabel ::v-deep .el-input__inner {
  height: 28px !important;
  line-height: 28px !important;
  font-weight: bold;
  text-align: left;
  margin-bottom: 5px;
}

.textOperator {
  color: #409eff;
  cursor: pointer;
}

.textOperator1 {
  color: #f56c6c;
  cursor: pointer;
  font-size: 22px;
}

.messgeList {
  height: 450px;
  background-color: #f5f5f5;
  margin-bottom: 20px;
  border-radius: 10px;
  padding: 10px;
  overflow-y: auto;
}

.downLink {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f5f7fa;
  cursor: pointer;
  padding: 5px;
}

.downModule {
  color: #409eff;
  text-decoration: underline;
  cursor: pointer;
  margin-right: 15px;
}
</style>
